import { api } from '@cwd/lib/main';

export interface AccountInvoice {
    InvoiceId: string;
    InvoiceNumber: number;
    RecipientName: string;
    RecipientEmail: string;
    CompanyName: string;
    Amount?: number;
    Vat?: number;
    CurrencyCode: string;
    Status: string;
    OrderTypes: string[];
    AmountPaid?: number;
    Created: Date;
    DueDate: Date;
    PaidDate?: Date;
    RemindersSent: number;
    LastReminderSent?: Date;
    CreatedByUserName: string;
    PaymentMethod: string;
}

export async function getInvoices(serviceSubscriptionId: string | null, includeCreditCard: boolean): Promise<AccountInvoice[]> {
    return api.get('/AccountInvoices?serviceSubscriptionId=' + serviceSubscriptionId + '&includeCreditCard=' + includeCreditCard);
}

export async function getRenderedInvoice(invoiceNumber: string, displayMode: string, serviceSubscriptionId: string | null): Promise<string> {
    return api.get(
        '/AccountInvoices/RenderInvoice?invoiceNo=' + invoiceNumber + '&invoiceDisplayMode=' + displayMode + '&serviceSubscriptionId=' + serviceSubscriptionId
    );
}
